// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4874":"css/admin-app.6869","8110":"css/app.6869"}[chunkId] + ".css";
};